var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('comitentes-online',{attrs:{"leilao":_vm.parseProps.leilao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }